import { connect } from 'react-redux';
import SignIn from '../components/signin/index';

import {
  loginWithToken,
  authenticateUserWithPassword,
  userExists,
  sendMagicLink,
} from '../actions/index';

import {
  getCurrentUser,
} from '../selectors/user-selector';

const actions = {
  onEmailChange: userExists,
  onClickSendMagicLink: sendMagicLink,
  onLoginWithToken: loginWithToken,
  onSignin: authenticateUserWithPassword,
};

const mapStateToProps = (state) => {
  const currentUser = getCurrentUser(state);

  return {
    currentUser,
    existence: state.users.existence,
  };
};

export default connect(mapStateToProps, actions)(SignIn);



// WEBPACK FOOTER //
// ./src/desktop/containers/signin.container.js